import React from 'react';

import styled from 'styled-components';

import type { SanitizedBillingSite, Site } from '@sine/sine-core-api-types';
import { Flex, ProfileImage, SpotIcon } from '@sine/sine-ui-components';

import type { HydratedBillableSite } from '../../../services/billing/billing.types';
import { getLicenceSpotIconType } from '../billing.helpers';

const StyledProfileImage = styled(ProfileImage)`
  flex-shrink: 0;
`;

interface SiteDisplayProps {
  planType?: string;
  site?: HydratedBillableSite | SanitizedBillingSite | Partial<Site>;
  showLogo?: boolean;
}

export default function SiteDisplay({ planType, site, showLogo = true }: SiteDisplayProps) {
  if (!site || ('isNew' in site && site.isNew)) {
    return (
      <Flex alignItems='center' gap={1}>
        <SpotIcon type={getLicenceSpotIconType(planType)} />
        <span>Assign site later</span>
      </Flex>
    );
  }

  if (showLogo && site.settings?.squareLogo?.url) {
    return (
      <Flex alignItems='center' gap={1}>
        <StyledProfileImage
          src={site.settings.squareLogo.url}
          firstName={site.name}
          placeholderStyle='initials'
          size='sm'
        />
        <div>
          <b>{site.name}</b>
        </div>
      </Flex>
    );
  }

  return (
    <div>
      <b>{site.name}</b>
    </div>
  );
}
